import { IPool } from "api/types/_pool";
import { Option } from "api/types/_public";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import CopyWrapper from "components/Common/CopyWrapper";
import DropdownTokenOption from "components/Common/DropdownTokenOption";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { LINK_FOR_NO_IMAGE, TOKENS_DEFAULT } from "helpers/constans";
import { formatScientificNumber, formatTokenNumber } from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import {
    NumberParam,
    StringParam,
    useQueryParams,
    withDefault,
} from "use-query-params";
import { getAllToken, getPoolsNormal, getTokens as onGetTokens } from "../../store/thunks";
import PoolForm from "./PoolForm";

const TYPE_SELECT_DEFAULT: string = "id";

const AllTransactions = () => {
    const { t, i18n } = useTranslation();

    const isFirstLoadingPageRef = useRef<any>(true);

    const TYPE_TRANSACTION_OPTIONS_LANG: any = [
        { value: 'Send', label: 'Send' },
        { value: 'Receive', label: 'Receive' },
        { value: 'Swap', label: 'Swap' },
        { value: 'Stake', label: 'Stake' },
        { value: 'Unstake', label: 'Unstake' },
        { value: 'Approve', label: 'Approve' },
        { value: 'Contract Call', label: 'Contract Call' },
        { value: 'Mint', label: 'Mint' },
        { value: 'Burn', label: 'Burn' },
        { value: 'Bridge', label: 'Bridge' },
    ]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const STATUS_TRANSACTION_OPTIONS_LANG: any = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Success', label: 'Success' },
        { value: 'Failed', label: 'Failed' },
        { value: 'Dropped', label: 'Dropped' },
        { value: 'Reverted', label: 'Reverted' },
        { value: 'Cancelled', label: 'Cancelled' }
    ]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        name: withDefault(StringParam, ""),
        // type: withDefault(StringParam, ""),
        // status: withDefault(StringParam, ""),
        token: withDefault(StringParam, ""),
        cursor: withDefault(StringParam, ""),
        // date_start: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
        // date_end: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    });

    const [tokenSearch, setTokenSearch] = useState<any>(query?.token ? { value: query?.token || '', label: '' } : null);

    const [typeSearch, setTypeSearch] = useState<Option | null>(TYPE_TRANSACTION_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.type)) || null);
    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_TRANSACTION_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.status)) || null);

    const [dateRangeSearch, setDateRangeSearch] = useState<any[]>([query?.date_start ? moment(query?.date_start, 'Y-MM-DD').toDate() : null, query?.date_end ? moment(query?.date_end || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateRangeSearch;

    const [listToken, setListToken] = useState<any[]>([]);

    const [poolDetail, setPoolDetail] = useState<IPool | null>(null);

    const [listPool, setListPool] = useState<any>([]);

    const [poolList, setPoolList] = useState<{ list: any[], total: number, cursor: string }>({ list: [], total: 0, cursor: '' });

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => {
        return { ...state.Pool, ...state.Token };
    };

    const PoolProperties = createSelector(selectLayoutState, (state) => ({
        pools: state.pools,
        isPoolSuccess: state.isPoolSuccess,
        isPoolLoading: state.isPoolLoading,
        tokens: state.tokens?.list || [],
        error: state.error,
    }));

    // Inside your component
    const { pools, tokens, error, isPoolLoading } = useSelector(PoolProperties);

    const handleQueryData = async () => {
        try {
            setIsLoading((prev) => true);
            const res: any = await getPoolsNormal(query);
            setPoolList((prev: any) => ({
                list: Number(query?.page) === 1 ? (res?.list || []) : (prev?.list || []).concat(res?.list || []),
                total: res?.pagination?.total || 0,
                cursor: res?.pagination?.cursor || ''
            }));
            setIsLoading((prev) => false);
        } catch (error: any) {
            setIsLoading((prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
        }
    };

    const handleLoadMore = () => {
        setQuery({
            ...query,
            page: query?.page + 1,
            cursor: poolList?.cursor || ''
        });
    };


    useEffect(() => {
        if (!!query?.token) {
            handleQueryData();
        }
    }, [JSON.stringify(query)]);

    useEffect(() => {
        dispatch(onGetTokens({}));
    }, []);

    const searchData = () => {
        isFirstLoadingPageRef.current = false;
        setPoolList((prev: any) => ({
            list: [],
            total: 0,
            cursor: '',
        }));
        setQuery({
            ...query,
            cursor: '',
            token: tokenSearch?.value || listPool[0]?.value || '',
            // type: typeSearch?.value,
            // status: statusSearch?.value,
            // date_start: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            // date_end: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
            page: 1,
            time_request: + new Date()
        });
    };

    const resetData = () => {
        isFirstLoadingPageRef.current = false;
        const queryNew = {
            token: listPool[0]?.value || '',
            cursor: '',
            // type: '',
            // status: '',
            // date_start: `${moment().format("Y-MM-DD")}`,
            // date_end: `${moment().format("Y-MM-DD")}`,
            // sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setPoolList((prev: any) => ({
            list: [],
            total: 0,
            cursor: ''
        }));
        setQuery(queryNew, "push");
        setTokenSearch(queryNew?.token || '');
        // setTypeSearch(null);
        // setStatusSearch(null);
        // setDateRangeSearch([moment(queryNew?.date_start || "", 'Y-MM-DD').toDate(), moment(queryNew?.date_end || "", 'Y-MM-DD').toDate()]);
    };


    const handleSetPoolDetail = (detail: IPool | null) => {
        setPoolDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetPoolDetail(null);
    }

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t("#"),
                accessor: "ID",
                filterable: true,
                sortable: false,
                thWidth: 50,
                Cell: (cell: any) => {
                    const item = cell?.row;
                    return (
                        <>
                            <span style={{ minWidth: "50px" }}>{item?.index + 1}</span>
                        </>
                    )
                },
            },
            {
                Header: t("Pool"),
                accessor: "Pool",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: "text-start",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    let LOGO_TOKEN = '';
                    if (!item?.pair?.[0]?.tokenLogo) {
                        LOGO_TOKEN = (listPool || [])?.find((_t: any) => _t?.value === item?.baseToken)?.logo || '';
                    }
                    return (
                        <>
                            <Link to={`https://solscan.io/account/${item?.pairAddress}`} target="_blank" className="d-inline-block">
                                <div className="d-flex text-start justify-content-start align-items-center gap-2 m-auto" style={{ minWidth: '200px' }}>
                                    <div className="w-[44px]">
                                        <img
                                            src={
                                                item?.pair?.[0]?.tokenLogo || LOGO_TOKEN || LINK_FOR_NO_IMAGE
                                            }
                                            style={{
                                                width: "44px",
                                                height: "44px",
                                                borderRadius: "22px",
                                            }}
                                            className="flex-shrink-0 object-fit-cover m-auto w-[44px] h-[44px] !rounded-full"
                                            alt={item?.exchangeName}
                                        />
                                    </div>
                                    <div className="d-flex flex-column">
                                        <div className="text-start" style={{ minWidth: "120px" }}>{item?.pair ? <span><strong className="bold me-1 fs-15">{String(item?.pairLabel)?.split('/')[0]}</strong>/<span className="ms-1 fs-12">{String(item?.pairLabel)?.split('/')[1]}</span></span> : "-"}</div>
                                        <div className="text-start fs-14 text-muted" style={{ minWidth: "100px" }}>
                                            {/* {item?.name || "-"} */}
                                            {!!item?.pairAddress ? <TooltipCustom
                                                title={t('Address')}
                                                className="d-inline-block vertical-align-middle"
                                                style={{ transform: 'translateY(2px)' }}
                                            >
                                                <CopyWrapper isShow={true} contentCopy={item?.pairAddress}>{(item?.pairAddress || '')?.slice(0, 5) + "..." + (item?.pairAddress || '')?.slice(-4)}</CopyWrapper>
                                            </TooltipCustom> : (item?.name || "-")}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </>
                    );
                },
            },
            {
                Header: t('Price'),
                accessor: "price",
                filterable: false,
                sortable: false,
                thClass: 'text-end',
                thWidth: 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end" style={{ minWidth: '130px' }}>
                            <div>
                                <TooltipCustom
                                    title={item?.usdPrice}
                                    className="d-inline-block vertical-align-middle ms-1"
                                    style={{ transform: 'translateY(2px)' }}
                                >
                                    {formatTokenNumber(item?.usdPrice, 9, '$')}
                                </TooltipCustom>
                            </div>
                            {/* <div>
                                {t('Native Price')}:
                            </div> */}
                        </div>
                    );
                }
            },

            // {
            //     Header: t('AGE'),
            //     accessor: "age",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('TXNS'),
            //     accessor: "txns",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            {
                Header: t('Price') + ' ' + '24H',
                accessor: "24h",
                filterable: false,
                sortable: false,
                thClass: 'text-end',
                thWidth: 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end" style={{ minWidth: '130px' }}>
                            <div>
                                <TooltipCustom
                                    title={item?.usdPrice24hrPercentChange}
                                    className="d-inline-block vertical-align-middle ms-1"
                                    style={{ transform: 'translateY(2px)' }}
                                >
                                    <span className={Number(item?.usdPrice24hrPercentChange) < 0 ? 'text-danger' : 'text-success'}>
                                        {formatScientificNumber(item?.usdPrice24hrPercentChange, 9, '')}%
                                    </span>
                                </TooltipCustom>
                            </div>
                            {/* <div className="fs-12 text-muted">
                                ({formatTokenNumber(item?.usdPrice24hrPercentChange, 6, '')}%)
                            </div> */}
                        </div>
                    );
                }
            },
            {
                Header: t('Label_Volume') + ' ' + '24H',
                accessor: "volume",
                filterable: false,
                sortable: false,
                thClass: 'text-end',
                thWidth: 150,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end" style={{ minWidth: '130px' }}>
                            <div>
                                <TooltipCustom
                                    title={item?.volume24hrUsd}
                                    className="d-inline-block vertical-align-middle ms-1"
                                    style={{ transform: 'translateY(2px)' }}
                                >
                                    {formatScientificNumber(item?.volume24hrUsd, 4, '$')}
                                </TooltipCustom>
                            </div>
                            {/* <div>
                                {t('Native Price')}: {item?.volume24hrNative}
                            </div> */}
                        </div>
                    );
                }
            },
            // {
            //     Header: t('Makers'),
            //     accessor: "makers",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('5M'),
            //     accessor: "5m",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('1H'),
            //     accessor: "1h",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('6H'),
            //     accessor: "6h",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },

            {
                Header: t('Liquidity'),
                accessor: "liquidity",
                filterable: false,
                sortable: false,
                thClass: 'text-end',
                thWidth: 180,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end" style={{ minWidth: '150px' }}>
                            <TooltipCustom
                                title={item?.liquidityUsd}
                                className="d-inline-block vertical-align-middle ms-1"
                                style={{ transform: 'translateY(2px)' }}
                            >
                                {formatTokenNumber(item?.liquidityUsd, 2, '')}
                            </TooltipCustom>
                        </div>
                    );
                }
            },
            // {
            //     Header: t('MCAP'),
            //     accessor: "mcap",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('Pool'),
            //     accessor: "pool",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-start',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const COLOR: any = {
            //             Internal: 'success',
            //             External: 'primary',
            //         };
            //         return (
            //             <div className="text-start" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('Yield') + ' / ' + t('TVL'),
            //     accessor: "yield",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const COLOR: any = {
            //             Internal: 'success',
            //             External: 'primary',
            //         };
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('Volume') + ' ' + t('24H'),
            //     accessor: "volume",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const COLOR: any = {
            //             Internal: 'success',
            //             External: 'primary',
            //         };
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('TVL'),
            //     accessor: "tvl",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const COLOR: any = {
            //             Internal: 'success',
            //             External: 'primary',
            //         };
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('Fees') + ' ' + t('24H'),
            //     accessor: "fees",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const COLOR: any = {
            //             Internal: 'success',
            //             External: 'primary',
            //         };
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t('Rewards') + ' ' + t('24H'),
            //     accessor: "rewards",
            //     filterable: false,
            //     sortable: false,
            //     thClass: 'text-end',
            //     thWidth: 150,
            //     Cell: (cell: any) => {
            //         const COLOR: any = {
            //             Internal: 'success',
            //             External: 'primary',
            //         };
            //         return (
            //             <div className="text-end" style={{ minWidth: '130px' }}>

            //             </div>
            //         );
            //     }
            // },
            // {
            //     Header: t("Created at"),
            //     accessor: "CreatedAt",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 130,
            //     thClass: "text-end",
            //     Cell: (cell: any) => {
            //         const arrDate = String(cell?.value || "").split("T");
            //         return (
            //             <div className="text-end" style={{ minWidth: "120px" }}>
            //                 <span>
            //                     <span>{arrDate?.[0] || ""}</span> <br />{" "}
            //                     <span className="text-secondary">{String(arrDate?.[1] || "")?.split('.')[0]}</span>{" "}
            //                 </span>
            //             </div>
            //         );
            //     },
            // },
            // {
            //     Header: t("Updated at"),
            //     accessor: "UpdatedAt",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 140,
            //     thClass: "text-end",
            //     Cell: (cell: any) => {
            //         const arrDate = String(cell?.value || "").split("T");
            //         return (
            //             <div className="text-end pe-2" style={{ minWidth: "120px" }}>
            //                 <span>
            //                     <span>{arrDate?.[0] || ""}</span> <br />{" "}
            //                     <span className="text-secondary">{String(arrDate?.[1] || "")?.split('.')[0]}</span>{" "}
            //                 </span>
            //             </div>
            //         );
            //     },
            // },
        ],
        [i18n?.language, query, listPool]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 });
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return { ..._prev, ...sortBy };
        });
    }, []);

    const handleChangeDateRangePicker = (values: any[] = []) => {
        setDateRangeSearch((_prev: any) => values);
    };

    useEffect(() => {
        const getList = async () => {
            try {
                const list = tokens?.map((item: any) => {
                    return {
                        value: item?.mint,
                        label: item?.symbol,
                        logo: item?.logo,
                        pair: item?.pair?.pairLabel || '',
                    };
                });
                setListPool(list);
                const tokenSelect = list?.find((item: any) => item?.value === query?.token) || list?.[0];
                setQuery({ ...query, token: tokenSelect?.value });
            } catch (error) {
                console.error(error);
            }
        };
        getList();
    }, [JSON.stringify(tokens)]);


    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const [res1]: any = await Promise.all([getAllToken({})]);
                const TOKENS = TOKENS_DEFAULT;
                setListToken((_prev) => (res1 || []).concat(TOKENS));
            } catch (error: any) {
                return error;
            }
        };
        handleCallAllOption();
    }, []);

    return (
        <React.Fragment>
            {/* <Row className="align-items-center mb-4 g-3">
                <Col sm={2}>
                    <div className="d-flex align-items-center gap-2">
                    </div>
                </Col>
                <div className="col-sm-auto ms-auto">
                    <div className="d-flex gap-2">
                        <Link to="#" data-bs-toggle="modal" className="btn btn-info" >Deposite</Link>
                        <Link to="#" data-bs-toggle="modal" className="btn btn-success">Withdraw</Link>
                    </div>
                </div>
            </Row> */}

            <Card>
                <CardHeader>
                    <Row className="align-items-center g-3 py-3">
                        <Col sm={5} md={3} className="mt-0">
                            <h5 className="card-title mb-0">
                                <span className="me-2">{t("Showing")}:</span>
                                {(isPoolLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                    start={0}
                                    end={poolList?.list?.length || 0}
                                    duration={1}
                                    className="text-primary"
                                />)}
                            </h5>
                        </Col>
                        <Col sm={7} md={9} className="text-end mt-0">
                            <div>
                                <button
                                    type="button"
                                    className="ms-3 btn btn-primary add-btn bg-[#009ef7] hover:bg-[#0086d2]"
                                    id="create-btn"
                                    onClick={() => {
                                        handleSetPoolDetail({} as IPool);
                                    }}
                                >
                                    <i className="ri-add-line align-bottom me-1"></i>
                                    {t('Create Pool')}
                                </button>
                            </div>
                        </Col>
                    </Row>
                    <Row className="g-4 align-items-center mt-0 border border-dashed border-end-0 border-start-0 border-bottom-0 py-2">
                        <Col sm={6} md={4} xl={3} xxl={3} className='mt-3'>
                            <LabelWrapper label={t('Token')} isShow={true}>
                                <DropdownTokenOption
                                    isMultiLang
                                    name="token"
                                    dataList={listPool}
                                    initialValue={tokenSearch || listPool?.[0]}
                                    onChangeSelect={(event: any) => { setTokenSearch((_prev: any) => event); }}
                                    className="dropdown-status-rounded z-hight"
                                    classNamePrefix="name-prefix"
                                    // className="bg-[#fff]"
                                    labelTop=""
                                // disabled={isLoading}
                                />
                            </LabelWrapper>
                        </Col>

                        {/* <Col sm={6} md={4} xl={3} xxl={2} className='mt-3'>
                            <LabelWrapper label={t('Type')} isShow={true}>
                                <DropdownStatus
                                    name="type"
                                    dataList={TYPE_TRANSACTION_OPTIONS_LANG || []}
                                    placeholder={`${t("Type")}...`}
                                    className="dropdown-status-rounded z-hight"
                                    classNamePrefix="name-prefix"
                                    initialValue={typeSearch || null}
                                    onChangeSelect={(e: any) => setTypeSearch(e)}
                                    isHasOptionAll={true}
                                    optionAll={{ label: t('All'), value: '' }}
                                    colors={COLOR_TYPE_TRANSACTION_OPTIONS}
                                    isColorObject={true}
                                    isColorStyle={true}
                                />
                            </LabelWrapper>
                        </Col> */}

                        {/* <Col sm={6} md={4} xl={3} xxl={3} className='mt-3 date-picker-wrapper-custom'>
                            <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                <DatePickerCustom
                                    placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                    startDate={startDate || null}
                                    endDate={endDate || null}
                                    onChangePicker={handleChangeDateRangePicker}
                                    showOptions={[
                                        'today', 'yesterday', 'two_day_ago',
                                        'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                        'this_week', 'last_week',
                                        'this_month', 'last_month',
                                    ]}
                                />
                            </LabelWrapper>
                        </Col> */}

                        <Col sm={6} md={8} xl={9} xxl={9} className="hstack gap-1 justify-content-center justify-content-sm-start mt-3">
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-primary me-2  bg-[#009ef7] hover:bg-[#0086d2]"
                                    onClick={searchData}
                                    disabled={isPoolLoading}
                                >
                                    <i className="ri-search-line align-bottom me-1"></i>{" "}
                                    {t('Button Search')}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary fs-14  bg-[#878a99] hover:bg-[#737582]"
                                    onClick={resetData}
                                >
                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                    {t('Button Reset')}
                                </button>
                            </div>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className="p-0">
                    <InfiniteScroll
                        dataLength={poolList?.list?.length || 0}
                        next={handleLoadMore}
                        scrollableTarget='scrollableDiv'
                        hasMore={poolList && poolList?.cursor ? true : false}
                        loader={''} // loader={<LoadingListNotify />}
                        scrollThreshold={'50%'}
                    >
                        <div className="mx-3 my-4 mt-3">
                            <TableContainer
                                className="custom-header-css"
                                divClass="table-responsive table-card"
                                tableClass="align-middle sticky-table-wallet"
                                theadClass="table-light"
                                columns={columns}
                                data={poolList?.list?.length ? poolList?.list : []}
                                customPageSize={query.limit}
                                customPageIndex={query.page - 1}
                                totalRecords={poolList?.total}
                                // customPageCount={1}
                                customPageCount={1}
                                handleChangePage={handleChangePage}
                                manualSorting={true}
                                sorting={{
                                    sort_by: query.sort_by,
                                    order_by: query.order_by,
                                }}
                                handleChangeSorting={handleChangeSorting}
                                isLoading={isLoading}
                                isShowPagination={false}
                                isShowLoadingBottom={query.page > 1}
                                isScrollToTop={false}
                            />
                        </div>
                    </InfiniteScroll>
                </CardBody>
            </Card>

            <PoolForm
                listToken={listToken}
                isOpen={!!poolDetail}
                detail={poolDetail}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
            />
        </React.Fragment>
    );
};

export default AllTransactions;